import { ACCEL_NEUTRAL, accelLevelColor, ACCEL_LEVELS, type AccelScale } from '../analysis/accel'

/** The colour strip for the acceleration colouring: braking (red) … coasting … driving (green). */
export default function AccelLegend({ scale }: { scale: AccelScale }) {
  const gradient = `linear-gradient(to right, ${accelLevelColor(-ACCEL_LEVELS)}, ${ACCEL_NEUTRAL} 50%, ${accelLevelColor(ACCEL_LEVELS)})`
  return (
    <div className="accel-legend" title="Colour along the racing lines: red braking, green accelerating">
      <span>−{scale.maxBrake.toFixed(1)} g</span>
      <span className="accel-bar" style={{ background: gradient }} />
      <span>+{scale.maxAccel.toFixed(1)} g</span>
    </div>
  )
}
